import React, { useCallback, useEffect, useRef } from "react";
import useEmblaCarousel from "embla-carousel-react";

const TWEEN_FACTOR_BASE = 0.52;

const numberWithinRange = (number, min, max) =>
  Math.min(Math.max(number, min), max);

const SwiperCard = (props) => {
  const { slides, options } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel({ ...options });
  const tweenFactor = useRef(0);
  const tweenNodes = useRef([]);
  const isDragging = useRef(false);

  const setTweenNodes = useCallback((emblaApi) => {
    tweenNodes.current = emblaApi.slideNodes().map((slideNode) => {
      return slideNode.querySelector(".embla__slide__number");
    });
  }, []);

  const setTweenFactor = useCallback((emblaApi) => {
    tweenFactor.current = TWEEN_FACTOR_BASE * emblaApi.scrollSnapList().length;
  }, []);

  const tweenScale = useCallback((emblaApi, event) => {
    const scrollProgress = emblaApi.scrollProgress();
    const slidesInView = emblaApi.slidesInView();
    const isScrollEvent = event?.type === "scroll";

    emblaApi.scrollSnapList().forEach((scrollSnap, snapIndex) => {
      const diffToTarget = scrollSnap - scrollProgress;

      if (isScrollEvent && !slidesInView.includes(snapIndex)) return;

      const tweenValue = 1 - Math.abs(diffToTarget * tweenFactor.current);
      const scale = numberWithinRange(tweenValue, 0.7, 1).toString();
      const tweenNode = tweenNodes.current[snapIndex];
      if (tweenNode) {
        tweenNode.style.transform = `scale(${scale})`;
        tweenNode.style.transition = isDragging ? "none" : "transform 0.3s ease";
      }
    });
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    setTweenNodes(emblaApi);
    setTweenFactor(emblaApi);
    tweenScale(emblaApi);

    emblaApi
      .on("reinit", setTweenNodes)
      .on("reinit", setTweenFactor)
      .on("reinit", tweenScale)
      .on("scroll", tweenScale)
      .on("settle", tweenScale) 
      .on("slidefocus", tweenScale)
      .on("pointerDown", () => { isDragging.current = true })
      .on("pointerUp", () => { isDragging.current = false; }); 
  }, [emblaApi, tweenScale]);

  return (
    <div className="embla  md:col-span-2">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {[
            "ReIq is an agentic mobile application that helps patient walk the journey of post hopsital discharge, ensuring that recovery at home is smooth, guided and supported."
            
          ].map((num) => (
            <div className="embla__slide" key={num}>
              <div className="embla__slide__number">{num}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SwiperCard;
